module.exports = __webpack_public_path__ + "static/media/customer_create.37139262.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/customer_create.svg
// module id = 476
// module chunks = 0